import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { authService } from '@/features/auth/services/auth.service'
import { useAuthStore } from '@/store/auth-store'

/**
 * Logout é melhor esforço (RF10): tenta revogar o refresh token no backend,
 * mas a sessão local é sempre limpa e o usuário sempre é redirecionado para
 * `/login` em `onSettled`, independente de sucesso ou falha da chamada (rede
 * indisponível, token já expirado, etc.). Por isso não há `onError` — do
 * ponto de vista do usuário o logout "funcionou" mesmo quando a revogação no
 * backend falha, então nenhum toast de erro é exibido.
 */
export function useLogout() {
  const navigate = useNavigate()
  const { accessToken, refreshToken, clearAuth } = useAuthStore()

  const mutation = useMutation({
    mutationFn: () =>
      refreshToken ? authService.logout({ refreshToken }, accessToken!) : Promise.resolve(),
    onSettled: () => {
      clearAuth()
      navigate('/login')
    },
  })

  return {
    logout: mutation.mutate,
    isPending: mutation.isPending,
  }
}
